import { useIntersection } from 'react-use';
import { isPositionStickySupported } from "../constants/commonConstants";

const useIsFullyVisible = ref => {
  const {intersectionRatio} = useIntersection(ref, {threshold: 1}) || {intersectionRatio: 0};
  return isPositionStickySupported === true && intersectionRatio !== 1;
};

export default useIsFullyVisible;